import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_DOMAINS_FOR_PAGE_BASIC_ATTRIBUTES } from './api/query'
import { Data, DomainSliceDTO, Variables } from './api/types'
import { DomainSlice, UseGetDomainsForSelect } from './types'

export const useGetDomainsForSelect = (): UseGetDomainsForSelect => {
  const { workspaceId } = useWorkspaceParam()
  const [domains, setDomains] = useState<SelectOption<DomainSlice>[]>([])

  useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        domains: { nodes: domains },
      } = data

      if (domains && domains.length > 0) {
        setDomains(
          domains.map((domain: DomainSliceDTO): SelectOption<DomainSlice> => fromDTO(domain)),
        )
      }
    },
    query: GET_DOMAINS_FOR_PAGE_BASIC_ATTRIBUTES,
    variables: { workspaceId },
  })

  return { domains }
}
